module.exports = __webpack_public_path__ + "img/60k_more_bank_logos_mobile.bf83a633.png";